<template>
  <div class="url-attributes-association-popup">
    <div class="url-attributes-association-popup__title">Associated URLs</div>
    <template v-if="!isErrorOnLoading && isDataLoaded">
      <div class="url-attributes-association-popup__attribute-info">
        <div class="url-attributes-association-popup__attribute-info_row">
          <div class="url-attributes-association-popup__attribute-info_name">
            URL Attribute Name
          </div>
          <div class="url-attributes-association-popup__attribute-info_status">
            Is Active
          </div>
        </div>
        <div class="url-attributes-association-popup__attribute-info_row">
          <div class="url-attributes-association-popup__attribute-info_name">
            {{ briefUrlAttributesAssociation.attributeName }}
          </div>
          <div class="url-attributes-association-popup__attribute-info_status">
            {{ isActive }}
          </div>
        </div>
      </div>
      <div class="url-attributes-association-popup__separator"></div>
      <div class="url-attributes-association-popup__urls" :style="{ height: urlsBlockHeight + 'px' }">
        <div class="url-attributes-association-popup__urls_header">URLs</div>
        <div
          v-for="url in briefUrlAttributesAssociation.urls"
          :key="url"
          class="url-attributes-association-popup__urls_url"
        >
          {{ url }}
        </div>
      </div>
      <div class="url-attributes-association-popup__separator"></div>
    </template>
    <div v-else-if="isDataLoaded" class="url-attributes-association-popup__no-data">
      Data Fetching Error
    </div>
    <div v-else class="url-attributes-association-popup__loader">
      <base-loader />
    </div>
    <button class="url-attributes-association-popup__close-btn" @click.prevent="close">close</button>
  </div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'UrlAttributesAssociationModal',
  mixins: [BaseModalMixins],
  props: {
    urlAttributeId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isDataLoaded: false,
      isErrorOnLoading: false,
      urlsBlockHeight: 0
    }
  },
  mounted () {
    this.recalculateHeight()
    window.addEventListener('resize', this.recalculateHeight)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.recalculateHeight)
  },
  watch: {
    urlAttributeId: {
      async handler (v) {
        if (v) {
          try {
            await this.getBriefURLAttributesAssociation(v)
          } catch (e) {
            this.isErrorOnLoading = true
          } finally {
            this.isDataLoaded = true
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('urlAttributes', ['briefUrlAttributesAssociation']),
    isActive () {
      return this.briefUrlAttributesAssociation.status ? 'Yes' : 'No'
    }
  },
  methods: {
    ...mapActions('urlAttributes', ['getBriefURLAttributesAssociation']),
    close () {
      this.$emit('cancel', this.isSomethingChanged)
    },
    recalculateHeight () {
      const modal = this.$parent.$el.querySelector('.rfx-modal')
      if (modal) {
        this.urlsBlockHeight = modal.clientHeight - 348
      }
    }
  }
}
</script>

<style lang="scss">
  .url-attributes-association-popup {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 40px;

    &__separator {
      border-top: 1px solid #e6e8ea;
      width: 690px;
      margin-left: -40px;
    }

    &__urls {
      padding-top: 24px;
      overflow: auto;

      &_url {
        margin-top: 8px;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.16px;
        color: $rfx-dark-march;
        white-space: nowrap;
      }

      &_header {
        font-size: 14px;
        line-height: 20px;
        height: 30px;
        color: $rfx-dark-march;
        font-weight: bold;
      }
    }

    &__attribute-info {
      margin-bottom: 24px;

      &_row {
        display: flex;

        &:first-child {
          .url-attributes-association-popup__attribute-info_name,
          .url-attributes-association-popup__attribute-info_status {
            height: 30px;
            font-weight: bold;
          }
        }
      }

      &_name,
      &_status {
        margin-top: 8px;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.16px;
        flex: 1;
        color: $rfx-dark-march;
      }
    }

    &__title {
      text-align: center;
      font-size: 32px;
      line-height: 1.5;
      letter-spacing: -0.32px;
      font-weight: bold;
      margin-bottom: 40px;
      color: $rfx-dark-march;
    }

    &__no-data {
      font-size: 27px;
      font-weight: 600;
      color: $rfx-medium-grey;
    }

    &__no-data,
    &__loader {
      width: -webkit-fill-available;
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__close-btn {
      color: #fff;
      letter-spacing: 1.25px;
      font-weight: 900;
      font-size: 10px;
      line-height: 4;
      padding: 0 32px;
      margin-top: 24px;
      background-color: #2f404e;
      align-self: flex-end;
      border-radius: 4px;
      border: none;
      text-transform: uppercase;
    }
  }
</style>
